export const JOB_AD_COLUMNS_SMALL_DEVICES = [
    'Basic',
    'Plus (Plus Starter)',
    'Premium',
];

export const JOB_AD_COLUMNS_LARGE_DEVICES = [
    'Produkte vergleichen',
    ...JOB_AD_COLUMNS_SMALL_DEVICES,
];

export const FEATURES = [
    {
        rows: [
            {
                data: [{ value: true }, { value: true }, { value: true }],
                title: 'Selbsteingabe',
            },
            {
                data: [{ value: true }, { value: true }, { value: true }],
                title: 'ChatGPT Eingabehilfe',
            },
            {
                data: [
                    {
                        label: '12 Monate',
                        value: true,
                    },
                    {
                        label: '12 Monate (Plus)<br>6 Monate (Plus Starter)',
                        value: true,
                    },
                    {
                        label: '12 Monate',
                        value: true,
                    },
                ],
                description:
                    'Ihr Stelleninserat können Sie innerhalb von 6 bis 12 Monaten ab Kauf online stellen.',
                title: 'Vertragszeitraum',
            },
            {
                data: [
                    {
                        label: '60 Tage ',
                        value: true,
                    },
                    {
                        label: '60 Tage (Plus)<br>30 Tage (Plus Starter)',
                        value: true,
                    },
                    {
                        label: '60 Tage',
                        value: true,
                    },
                ],
                description: 'Die Zeit, die Ihre Stelleninserat online ist.',
                title: 'Laufzeit',
            },
        ],
    },
    {
        rows: [
            {
                data: [
                    { label: 'alle 20 Tage', value: true },
                    { label: 'alle 10 Tage', value: true },
                    { label: 'alle 10 Tage', value: true },
                ],
                description:
                    'Ihr Stelleninserat wird alle paar Tage automatisch in der Jobsuche vorgereiht.',
                title: 'Automatische Vorreihung',
            },
            {
                data: [
                    {
                        label: 'Zusätzlich buchbar<br>',
                        linkLabel: 'Zur Online-Buchung',
                        url: '/produkte/stelleninserate/job-ad-basic-runtime-60',
                        value: false,
                    },
                    {
                        label: 'Zusätzlich buchbar<br>',
                        linkLabel: 'Zur Online-Buchung',
                        url: '/produkte/stelleninserate/job-ad-plus-runtime-60',
                        value: false,
                    },
                    { label: 'Alle 10 Tage', value: true },
                ],
                description:
                    'Der Job-Push ist eine Zusatzleistung, mit der Ihr Stelleninserat sieben Tage lang prominenter platziert wird. Dadurch wird das Stelleninserat besser sichtbar und erhält mehr Zugriffe. Der Job-Push ist <strong>nur</strong> beim Stelleninserat Premium inklusive. Bei allen anderen Stelleninseraten kann der Job-Push zusätzlich dazu gebucht werden.',
                title: 'Job-Push inklusive',
            },
            {
                data: [
                    { value: true },
                    { value: true },
                    { label: '+ Visuelle Hervorhebung', value: true },
                ],
                description:
                    'Jobsuchende, die den Job-Alarm abonnieren, erhalten Ihre Stellenanzeige per Mail.',
                title: 'Job-Alarm',
            },
            {
                data: [{ value: true }, { value: true }, { value: true }],
                description:
                    'Jobsuchende bekommen auf Basis Ihrer angegebenen Wünsche und Fähigkeiten passende Stellenanzeigen per Mail zugeschickt.',
                title: 'Job-Empfehlung',
            },
        ],
        title: 'Sichtbarkeit auf karriere.at',
    },
    {
        rows: [
            {
                data: [{ value: false }, { value: true }, { value: true }],
                title: 'Farboptionen entsprechend der Unternehmensmarke',
            },
            {
                data: [
                    { value: false },
                    { label: 'max. 1', value: true },
                    { label: 'max. 1', value: true },
                ],
                title: 'Titelbild',
            },
            {
                data: [
                    { value: false },
                    { label: 'max. 3', value: true },
                    { label: 'max. 3', value: true },
                ],
                title: 'Bilder',
            },
            {
                data: [
                    { value: false },
                    { label: 'max. 1', value: true },
                    { label: 'max. 1', value: true },
                ],
                title: 'Video',
            },
            {
                data: [{ value: false }, { value: true }, { value: true }],
                description:
                    'Der Gehaltsgraph stellt Ihre angegebenen Gehaltsspannen visuell ansprechend dar.',
                title: 'Gehaltsgraph',
            },
        ],
        title: 'Sichtbarkeit durch individuelles Design',
    },
    {
        rows: [
            {
                data: [{ value: true }, { value: true }, { value: true }],
                description:
                    'Platzierung Ihres Stelleninserats auf relevanten Partnerseiten, z.B. jobradius.at, itstellen.at, techtalents.at, financejobs.at, salescareer.at uvm.',
                title: 'Platzierung auf Partnerseiten',
            },
            {
                data: [{ value: true }, { value: true }, { value: true }],
                title: 'Platzierung auf Google for Jobs',
            },
            {
                data: [{ value: false }, { value: true }, { value: true }],
                description:
                    'Ideal für ein Stelleninserat mit starkem lokalem Fokus. Ihr Stelleninserat erscheint zielgerichtet auf einer von 600 Gemeinde-Websites.',
                title: 'Platzierung auf Gemeinde-Websites',
            },
            {
                data: [{ value: false }, { value: true }, { value: true }],
                description:
                    'Ihr Stelleninserat wird auf den aktuell performantesten Metajobbörsen platziert.',
                title: 'Platzierung auf Metajobbörsen',
            },
            {
                data: [{ value: false }, { value: false }, { value: true }],
                description:
                    'Ihr Stelleninserat wird auf den hochwertigsten Werbeplätzen im Web für maximale Reichweite platziert. Beispiele für Premium-Publisher sind derstandard.at, finanzen.net, meinbezirk.at, wetter.at, kurier.at usw.',
                title: 'Platzierung auf Premium-Publishern',
            },
        ],
        title: 'Reichweite durch externe Platzierungen',
    },
    {
        rows: [
            {
                data: [{ value: true }, { value: true }, { value: true }],
                description:
                    'Ihr Stelleninserat bekommt höchste Sichtbarkeit in den Google-Suchergebnissen.',
                title: 'Bewerbung in der Google-Suche',
            },
            {
                data: [{ value: false }, { value: true }, { value: true }],
                description:
                    'Ihr Stelleninserat wird mithilfe personalisierter Werbebanner auf Websites des Google-Werbenetzwerks beworben.',
                title: 'Bewerbung im Google Werbenetzwerk',
            },
            {
                data: [{ value: false }, { value: true }, { value: true }],
                title: 'Bewerbung mit Social Media Ads inkl. Ihrem Logo',
            },
            {
                data: [{ value: false }, { value: true }, { value: true }],
                title: 'Bewerbung im Web mit personalisierten Bannern',
            },
        ],
        title: 'Reichweite durch Bewerbungen online',
    },

    {
        rows: [
            {
                data: [{ value: true }, { value: true }, { value: true }],
                description:
                    'Im Business Portal erstellen und verwalten Sie Ihre Produkte und behalten die Performance Ihrer Stelleninserate im Blick.',
                title: 'Business Portal',
            },
            {
                data: [{ value: true }, { value: true }, { value: true }],
                description:
                    'Das kostenfreie Arbeitgeberprofil bietet grundlegende Informationen über Ihr Unternehmen für Talente.',
                title: 'employer.page',
            },

            {
                data: [{ value: true }, { value: true }, { value: true }],
                description:
                    'Der optimierte Bewerbungsprozess von karriere.at, gekennzeichnet durch den smart bewerben-Button auf dem Stelleninserat, führt zu doppelt so vielen Bewerbungs-Klicks im Vergleich zu Stelleninseraten ohne diese Optimierung. (Quelle: Google Analytics, März 2025)',
                title: 'smart bewerben',
            },
        ],
        title: 'Inklusivleistungen',
    },

    {
        rows: [
            {
                data: [
                    {
                        label: 'Zusätzlich buchbar<br>ab € 450<br>',
                        linkLabel: 'Zur Online-Buchung',
                        url: '/produkte/stelleninserate/job-ad-basic-runtime-60',
                        value: false,
                    },
                    {
                        label: 'Zusätzlich buchbar<br>ab € 450 (€ 320 für 5 Tage Plus Starter)<br>',
                        linkLabel: 'Zur Online-Buchung',
                        url: '/produkte/stelleninserate/job-ad-plus-runtime-60',
                        value: false,
                    },
                    { label: '<strong>inklusive</strong>', value: true },
                ],
                description:
                    'Job-Push ist eine Zusatzleistung, mit der Ihr Stelleninserat sieben Tage lang prominenter platziert wird. Dadurch wird das Stelleninserat besser sichtbar und erhält mehr Zugriffe. Der Job-Push ist nur beim Stelleninserat Premium inklusive. Bei allen anderen Stelleninseraten kann der Job-Push zusätzlich dazu gebucht werden.',
                title: 'Job-Push',
            },
            {
                data: [
                    {
                        label: 'Zusätzlich buchbar<br>ab € 340<br>',
                        linkLabel: 'Zur Online-Buchung',
                        url: '/produkte/stelleninserate/job-ad-basic-runtime-90',
                        value: false,
                    },
                    {
                        label: 'Zusätzlich buchbar<br>ab € 410<br>',
                        linkLabel: 'Zur Online-Buchung',
                        url: '/produkte/stelleninserate/job-ad-plus-runtime-90',
                        value: false,
                    },
                    {
                        label: 'Zusätzlich buchbar<br>ab € 550<br>',
                        linkLabel: 'Zur Online-Buchung',
                        url: '/produkte/stelleninserate/job-ad-premium-runtime-90',
                        value: false,
                    },
                ],
                description:
                    '+30 Tage Laufzeitverlängerung zubuchbar zu Ihrem aktiven Stelleninserat.',
                title: 'Laufzeitverlängerung',
            },
        ],
        title: 'Zusatzleistungen',
    },

    {
        rows: [
            {
                data: [{ value: true }, { value: true }, { value: true }],
                description:
                    'Bei aktivem Stelleninserat und gebuchten Kontaktanfragen in unserer Talentdatenbank schlagen wir Ihnen automatisch passende Kandidat*innen direkt in der Talentdatenbank vor. So sparen Sie Zeit bei der Suche nach Kandidat*innen und können diese direkt anschreiben.',
                title:
                    'Kontaktanfragen in der Talentdatenbank: Automatisiertes Kandidat*innen-Matching \n' +
                    'bei aktivem Stelleninserat',
            },
        ],
        title: 'Vorteile von Produktkombinationen',
    },
];
